/* eslint-disable react/no-unused-prop-types */
import useLoading from 'hooks/useLoading';
import React, { FormEvent, ReactNode } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

export type variants =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'dark'
  | 'light'
  | 'link'
  | 'outline-primary'
  | 'outline-secondary'
  | 'outline-success'
  | 'outline-danger'
  | 'outline-warning'
  | 'outline-info'
  | 'outline-dark'
  | 'outline-light'
  | 'blank';
type size = 'sm' | 'lg';
export interface ModalProps {
  title: string;
  disabled?: boolean;
  onSubmit: () => Promise<boolean | undefined>;
  buttonSize?: size;
  onClose: () => void;
  open: boolean,
  children: ReactNode
}
export interface VariantModalProps extends ModalProps{
  variant?: variants;
}
interface Props extends VariantModalProps {
  buttonText: string;
}

const FormModal: React.FC<Props> = ({
  title,
  disabled,
  buttonText,
  onSubmit,
  open,
  onClose,
  children,
}) => {
  const [loading, setLoading] = useLoading(false);

  const formSubmit = async (event: FormEvent) => {
    setLoading(true);
    event.preventDefault();
    event.stopPropagation();
    const shouldClose = await onSubmit();
    if (shouldClose) onClose();
    setLoading(false);
  };
  return (
    <Modal show={open} onHide={onClose}>
      <form onSubmit={formSubmit}>
        <Modal.Title>{title}</Modal.Title>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            disabled={loading || disabled}
            type="submit"
          >
            {buttonText}
            {' '}
            {loading && <Spinner animation="border" size="sm" />}
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Luk
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
export default FormModal;
